// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__5tPVb","Large":"Loader_Large__ZaDqo","Small":"Loader_Small__A0kEs"};